<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-examinee-information`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 6a2 2 0 011.995 1.85L46 8v32a2 2 0 01-1.85 1.995L44 42H4a2 2 0 01-1.995-1.85L2 40V8a2 2 0 011.85-1.995L4 6h40zm-2 4H6v28h36V10zm-21 6a1 1 0 011 1v14a1 1 0 01-1 1H11a1 1 0 01-1-1V17a1 1 0 011-1h10zm17 11a1 1 0 011 1v2a1 1 0 01-1 1H26a1 1 0 01-1-1v-2a1 1 0 011-1h12zm-20-7h-4v8h4v-8zm16-2a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8z"/></svg>
</template>
<script>

export default {
  name: 'IconExamineeInformation',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
